'use client';

import { useEffect, useState } from 'react';

import { fetchAboutPageExact } from '@/services/api';
import { AboutPageData } from '@/services/types';

export interface UseAboutPageReturn {
  data: AboutPageData | null;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

/**
 * Custom hook for fetching About page data
 */
export function useAboutPage(): UseAboutPageReturn {
  const [data, setData] = useState<AboutPageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);

      const aboutData = await fetchAboutPageExact();

      if (aboutData) {
        setData(aboutData);
      } else {
        const errorMsg = 'Failed to fetch about page data - no data returned';
        setError(errorMsg);
      }
    } catch (err) {
      const errorMsg = err instanceof Error ? err.message : 'An error occurred';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const refetch = async () => {
    await fetchData();
  };

  return {
    data,
    loading,
    error,
    refetch,
  };
}
